// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.confirmation-dialog {
  width: 100%;
  max-width: 650px;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.confirmation-dialog .dialog-header {
  padding: 20px 24px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  flex: 1;
  line-height: 1.3;
}
.confirmation-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.confirmation-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.confirmation-dialog .dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.confirmation-dialog .dialog-header .close-button:focus {
  outline: none;
}
.confirmation-dialog .dialog-header .close-button:focus-visible {
  outline: none;
}
.confirmation-dialog .dialog-header .close-button mat-icon {
  font-family: "Material Icons" !important;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirmation-dialog .confirmation-content {
  padding: 0 24px 24px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirmation-dialog .confirmation-content .status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0 20px;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  transition: all 0.3s ease;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.approve {
  background-color: #e8f5e8;
  color: #2e7d32;
  border: 2px solid #4caf50;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.reject {
  background-color: #ffebee;
  color: #c62828;
  border: 2px solid #f44336;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.rework {
  background-color: #fff3e0;
  color: #ef6c00;
  border: 2px solid #ff9800;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.cancel {
  background-color: #f3e5f5;
  color: #7b1fa2;
  border: 2px solid #9c27b0;
}
.confirmation-dialog .confirmation-content .confirmation-message {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  text-align: left;
}
.confirmation-dialog .confirmation-content .confirmation-message .status-message,
.confirmation-dialog .confirmation-content .confirmation-message .next-steps {
  text-align: left;
}
.confirmation-dialog .confirmation-content .confirmation-message ul {
  margin: 8px 0 0 0;
  padding-left: 24px;
  list-style-position: outside;
  text-align: left;
}
.confirmation-dialog .confirmation-content .confirmation-message li {
  text-align: left;
  display: list-item;
}
.confirmation-dialog .confirmation-content .request-details {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.confirmation-dialog .confirmation-content .request-details .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .request-details .detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 0;
  min-height: 24px;
}
.confirmation-dialog .confirmation-content .request-details .detail-item:last-child {
  margin-bottom: 0;
}
.confirmation-dialog .confirmation-content .request-details .detail-item .label {
  font-weight: 600;
  color: #666;
  min-width: 120px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 16px;
  font-size: 14px;
  line-height: 1.4;
}
.confirmation-dialog .confirmation-content .request-details .detail-item .value {
  color: #333;
  flex: 1;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.4;
  padding-left: 8px;
  font-weight: 500;
}
@media (max-width: 600px) {
  .confirmation-dialog .confirmation-content .request-details {
    padding: 16px;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item .label {
    min-width: auto;
    text-align: left;
    padding-right: 0;
    padding-bottom: 4px;
    font-size: 13px;
    color: #555;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item .value {
    padding-left: 0;
    font-size: 14px;
    font-weight: 600;
    color: #222;
  }
}
.confirmation-dialog .confirmation-content .comment-section {
  margin-top: 24px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .comment-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field {
  margin-top: 8px;
  width: 100%;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field textarea {
  font-size: 14px;
  line-height: 1.5;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-wrapper {
  padding-bottom: 0;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-underline {
  display: none;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-outline {
  border-radius: 6px;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  align-content: center !important;
  gap: 12px !important;
  background-color: #fafafa !important;
  flex-shrink: 0;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  min-height: 76px !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button {
  min-width: 100px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;
  padding: 12px 20px !important;
  border: none !important;
  cursor: pointer !important;
  font-family: inherit !important;
  height: 44px !important;
  min-height: 44px !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  align-self: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  box-sizing: border-box !important;
  background-color: transparent !important;
  color: inherit !important;
  border: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button mat-icon,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button mat-icon {
  margin-right: 6px;
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  overflow: visible !important;
  visibility: visible !important;
  opacity: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn:hover {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn {
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  overflow: visible !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve {
  background: #5ea1d8 !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve:hover {
  background: #4a90c6 !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject {
  background: #5ea1d8 !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject:hover {
  background: #4a90c6 !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework {
  background: #5ea1d8 !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework:hover {
  background: #4a90c6 !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel {
  background: #5ea1d8 !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel:hover {
  background: #4a90c6 !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel:active {
  transform: translateY(0) !important;
}

/* Flow Completion–style primary/secondary buttons for ALL confirmation dialogs */
.confirmation-dialog mat-dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  margin-top: 4px;
}
.confirmation-dialog mat-dialog-actions .btn-primary,
.confirmation-dialog mat-dialog-actions .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-family: "Raleway", sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.confirmation-dialog mat-dialog-actions .btn-primary mat-icon,
.confirmation-dialog mat-dialog-actions .btn-secondary mat-icon {
  margin-right: 8px;
  font-family: "Material Icons" !important;
  font-size: 20px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.confirmation-dialog mat-dialog-actions .btn-primary:disabled,
.confirmation-dialog mat-dialog-actions .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.confirmation-dialog mat-dialog-actions .btn-primary {
  background: #5ea1d8;
  color: #ffffff;
}
.confirmation-dialog mat-dialog-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.confirmation-dialog mat-dialog-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.confirmation-dialog mat-dialog-actions .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}

/* Simplified visual style for generic stay/leave discard dialog */
.confirmation-dialog.simple-confirmation {
  width: 100% !important;
  max-width: 500px !important;
  min-width: 400px !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  background: #ffffff !important;
  border-radius: 22px !important;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35) !important;
  overflow: hidden !important;
  position: static !important;
}
.confirmation-dialog.simple-confirmation .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  position: static !important;
}
.confirmation-dialog.simple-confirmation .dialog-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #333;
}
.confirmation-dialog.simple-confirmation .dialog-header .close-button {
  color: #666 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.confirmation-dialog.simple-confirmation .dialog-header .close-button ::ng-deep .mat-mdc-button-base,
.confirmation-dialog.simple-confirmation .dialog-header .close-button ::ng-deep .mdc-icon-button,
.confirmation-dialog.simple-confirmation .dialog-header .close-button ::ng-deep .mat-mdc-icon-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.confirmation-dialog.simple-confirmation .dialog-header .close-button ::ng-deep .mdc-icon-button__ripple {
  background: transparent !important;
}
.confirmation-dialog.simple-confirmation .dialog-header .close-button:hover, .confirmation-dialog.simple-confirmation .dialog-header .close-button:focus, .confirmation-dialog.simple-confirmation .dialog-header .close-button:active {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.confirmation-dialog.simple-confirmation .confirmation-content {
  padding: 32px 24px;
  text-align: left;
}
.confirmation-dialog.simple-confirmation .confirmation-content .confirmation-message {
  margin: 0;
  padding: 0;
  border-left: none;
  background: transparent;
}
.confirmation-dialog.simple-confirmation .confirmation-content .confirmation-message .status-message {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
}
.confirmation-dialog.simple-confirmation .confirmation-content .confirmation-message .status-message .next-steps {
  margin-top: 12px;
  padding: 0;
  background: transparent;
}
.confirmation-dialog.simple-confirmation .confirmation-content .confirmation-message .status-message .next-steps ul {
  margin: 8px 0 0 0;
  padding-left: 24px;
  list-style-position: outside;
  text-align: left;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions {
  padding: 25px !important;
  margin: 0 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
  background-color: #fff !important;
  position: static !important;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-primary,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-family: "Raleway";
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-primary:disabled,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-primary {
  background: #5ea1d8;
  color: white;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-button,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-raised-button {
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 8px !important;
  padding: 10px 16px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  overflow: visible !important;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-button ::ng-deep .mat-mdc-button-base,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-button ::ng-deep .mdc-button,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-raised-button ::ng-deep .mat-mdc-button-base,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-raised-button ::ng-deep .mdc-button {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  padding: 10px 16px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-button ::ng-deep .mat-button-wrapper,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-button ::ng-deep .mdc-button__label,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-raised-button ::ng-deep .mat-button-wrapper,
.confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions button.mat-raised-button ::ng-deep .mdc-button__label {
  white-space: nowrap !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  font-size: 16px !important;
}

.confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
}

.confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.approve {
  background: #5ea1d8 !important;
  color: white !important;
  border: none !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 20px !important;
  overflow: visible !important;
}

::ng-deep .mat-dialog-container {
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
  max-height: 90vh !important;
  overflow: visible !important;
  box-sizing: border-box !important;
}
::ng-deep .mat-dialog-container .confirmation-dialog {
  overflow: visible !important;
}
::ng-deep .mat-dialog-container .confirmation-dialog mat-dialog-actions {
  overflow: visible !important;
}
::ng-deep .mat-dialog-container .confirmation-dialog mat-dialog-actions button {
  overflow: visible !important;
}
::ng-deep .mat-dialog-container .confirmation-dialog mat-dialog-actions button .mat-icon {
  overflow: visible !important;
  visibility: visible !important;
}

::ng-deep .confirmation-dialog mat-dialog-actions {
  justify-content: flex-end !important;
  align-items: center !important;
}

.confirmation-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.dialog-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.confirmation-content {
  overflow-y: auto;
}

mat-dialog-actions.mat-dialog-actions {
  position: sticky;
  bottom: 0;
  background: #fafafa;
  z-index: 2;
  overflow: visible !important;
}

/* Align actions */
mat-dialog-actions.mat-dialog-actions {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px;
  padding: 16px 24px !important;
  overflow: visible !important;
  min-height: 76px !important;
}

/* Normalize MDC buttons inside actions */
mat-dialog-actions .mat-mdc-button-base {
  height: 44px !important;
  min-height: 44px !important;
  min-width: 120px;
  padding: 0 20px !important;
  margin: 6px;
  border-radius: 4px;
  box-sizing: border-box;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: visible !important;
}

/* Ensure the internal MDC label area uses flex for icon/text alignment */
mat-dialog-actions .mat-mdc-button-base .mdc-button__label {
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px;
  line-height: 1;
  overflow: visible !important;
}

/* Standardize icon size/alignment */
mat-dialog-actions .mat-mdc-button-base .mat-icon {
  font-size: 20px !important;
  height: 20px !important;
  width: 20px !important;
  line-height: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: visible !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Visual for cancel button to match sizing */
button.cancel-btn {
  border: 1px solid #ddd;
  background-color: #f8f9fa;
  color: #444;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Flowchest button style overrides */
.confirmation-dialog mat-dialog-actions button.confirm-btn.approve {
  background: #5ea1d8 !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;
}

.confirmation-dialog mat-dialog-actions button.confirm-btn.approve:hover {
  background: #4a90c6 !important;
}

.confirmation-dialog mat-dialog-actions button.confirm-btn.reject,
.confirmation-dialog mat-dialog-actions button.confirm-btn.cancel {
  background: #5ea1d8 !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 20px !important;
  overflow: visible !important;
}

.confirmation-dialog mat-dialog-actions button.confirm-btn.reject:hover {
  background: #4a90c6 !important;
}

@media (max-width: 600px) {
  mat-dialog-actions.mat-dialog-actions {
    flex-direction: column;
    align-items: stretch;
  }
  mat-dialog-actions .mat-mdc-button-base {
    width: 100%;
    margin: 6px 0;
  }
}
@media (max-width: 600px) {
  .confirmation-dialog {
    width: calc(100vw - 24px);
    max-width: 415px;
    margin: 12px auto;
    border-radius: 0;
    display: flex !important;
    flex-direction: column !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .confirmation-dialog .dialog-header {
    padding: 16px 16px 0;
  }
  .confirmation-dialog .dialog-header h2 {
    font-size: 18px;
    line-height: 1.2;
  }
  .confirmation-dialog .dialog-header .close-button {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
  }
  .confirmation-dialog .dialog-header .close-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .confirmation-dialog .confirmation-content {
    padding: 12px 16px 16px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
  }
  .confirmation-dialog mat-dialog-actions {
    position: sticky;
    bottom: 0;
    background: #fafafa;
    flex-direction: column !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .confirmation-dialog mat-dialog-actions button {
    width: 100% !important;
    margin-bottom: 8px !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .confirmation-dialog mat-dialog-actions button:last-child {
    margin-bottom: 5px !important;
  }
  ::ng-deep .mat-dialog-container {
    max-height: 100vh !important;
  }
}
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
  background-image: none !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.approve,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.reject,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.rework,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.cancel {
  background: #5ea1d8 !important;
  background-image: none !important;
  color: white !important;
  border: none !important;
  background-color: #5ea1d8 !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 20px !important;
  overflow: visible !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.approve:hover,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.reject:hover,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.rework:hover,
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.cancel:hover {
  background: #4a90c6 !important;
  background-color: #4a90c6 !important;
}

:host-context(body.theme-dark) .confirmation-dialog,
:host-context(body.theme-dark) .confirmation-dialog .dialog-header,
:host-context(body.theme-dark) .confirmation-dialog .confirmation-content,
:host-context(body.theme-dark) .confirmation-dialog .request-details,
:host-context(body.theme-dark) .confirmation-dialog .comment-section,
:host-context(body.theme-dark) .confirmation-dialog .comment-form-section,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions.mat-dialog-actions {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .confirmation-dialog.simple-confirmation,
:host-context(body.theme-dark) .confirmation-dialog.simple-confirmation .dialog-header,
:host-context(body.theme-dark) .confirmation-dialog.simple-confirmation .confirmation-content,
:host-context(body.theme-dark) .confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .confirmation-dialog h2,
:host-context(body.theme-dark) .confirmation-dialog h3,
:host-context(body.theme-dark) .confirmation-dialog h4,
:host-context(body.theme-dark) .confirmation-dialog p,
:host-context(body.theme-dark) .confirmation-dialog span,
:host-context(body.theme-dark) .confirmation-dialog label,
:host-context(body.theme-dark) .confirmation-dialog .section-title,
:host-context(body.theme-dark) .confirmation-dialog .detail-item .label,
:host-context(body.theme-dark) .confirmation-dialog .detail-item .value,
:host-context(body.theme-dark) .confirmation-dialog .confirmation-message,
:host-context(body.theme-dark) .confirmation-dialog .status-message,
:host-context(body.theme-dark) .confirmation-dialog .next-steps,
:host-context(body.theme-dark) .confirmation-dialog .next-steps li,
:host-context(body.theme-dark) .confirmation-dialog .close-button,
:host-context(body.theme-dark) .confirmation-dialog .close-button mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .confirmation-dialog .confirmation-message {
  background: #1f2937 !important;
  border-left-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .confirmation-dialog .request-details,
:host-context(body.theme-dark) .confirmation-dialog .comment-form-section {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .confirmation-dialog .close-button:hover {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-secondary,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .cancel-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-primary,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .confirm-btn {
  background: #2563eb !important;
  color: #ffffff !important;
  border-color: #2563eb !important;
}
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions button,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions button span,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions button .mdc-button__label,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions button mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-primary,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-primary span,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-primary .mdc-button__label,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .btn-primary mat-icon,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .confirm-btn,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .confirm-btn span,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .confirm-btn .mdc-button__label,
:host-context(body.theme-dark) .confirmation-dialog mat-dialog-actions .confirm-btn mat-icon {
  color: #ffffff !important;
}

/* Comment Form Styling */
.comment-form-section {
  margin: 20px 24px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.comment-form-section .example-form {
  margin: 0;
}
.comment-form-section .example-form .w-100 {
  width: 100%;
}
.comment-form-section .example-form .font16 {
  font-size: 16px;
  font-weight: 500;
  color: #495057;
}
.comment-form-section .example-form mat-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff;
  border-radius: 6px;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-focus-overlay {
  background-color: transparent;
}
.comment-form-section .example-form mat-form-field input {
  font-size: 14px;
  color: #495057;
}
.comment-form-section .example-form mat-form-field input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-hint {
  color: #6c757d;
  font-size: 12px;
}

@media (max-width: 600px) {
  .comment-form-section {
    margin: 12px 12px;
    padding: 12px;
  }
}
/* Spacing adjustments for better padding */
.dialog-header {
  padding: 16px 24px 0;
}

.confirmation-content {
  padding: 16px 24px 16px;
}

.comment-form-section {
  margin: 16px 24px;
  padding: 16px;
}

mat-dialog-actions.mat-dialog-actions {
  padding: 16px 24px !important;
  overflow: visible !important;
}

::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-button,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-raised-button,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-unelevated-button {
  overflow: visible !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 20px !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-button .mdc-button,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-raised-button .mdc-button,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-unelevated-button .mdc-button {
  overflow: visible !important;
  height: 44px !important;
  min-height: 44px !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-button .mdc-button .mdc-button__label,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-raised-button .mdc-button .mdc-button__label,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-unelevated-button .mdc-button .mdc-button__label {
  overflow: visible !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-button .mdc-button .mdc-button__label mat-icon,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-raised-button .mdc-button .mdc-button__label mat-icon,
::ng-deep .confirmation-dialog mat-dialog-actions .mat-mdc-unelevated-button .mdc-button .mdc-button__label mat-icon {
  overflow: visible !important;
  visibility: visible !important;
  opacity: 1 !important;
  font-size: 20px !important;
  height: 20px !important;
  width: 20px !important;
  line-height: 20px !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions button.confirm-btn {
  background: #5ea1d8 !important;
  color: #fff !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions button.confirm-btn:hover {
  background: #4a90c6 !important;
}

/* Add border on all sides for action buttons */
mat-dialog-actions.mat-dialog-actions button.mat-button,
mat-dialog-actions.mat-dialog-actions button.mat-raised-button,
mat-dialog-actions .mat-mdc-button-base {
  overflow: visible !important;
}
mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn,
mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn,
mat-dialog-actions .mat-mdc-button-base.cancel-btn {
  border: 1px solid #ddd;
}
mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn,
mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn,
mat-dialog-actions .mat-mdc-button-base.confirm-btn {
  border: none !important;
}

body.theme-dark .mat-mdc-dialog-container,
body.theme-dark .mdc-dialog__container,
body.theme-dark .mdc-dialog__surface {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dialog-content,
body.theme-dark .dialog-body,
body.theme-dark .modal-content,
body.theme-dark .confirmation-dialog,
body.theme-dark .response-dialog {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dialog-content input,
body.theme-dark .dialog-body input,
body.theme-dark .dialog-content select,
body.theme-dark .dialog-body select,
body.theme-dark .dialog-content textarea,
body.theme-dark .dialog-body textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dialog-content p,
body.theme-dark .dialog-body p,
body.theme-dark .dialog-content span:not(.material-icons),
body.theme-dark .dialog-body span:not(.material-icons),
body.theme-dark .dialog-content label,
body.theme-dark .dialog-body label,
body.theme-dark .dialog-content h1,
body.theme-dark .dialog-body h1,
body.theme-dark .dialog-content h2,
body.theme-dark .dialog-body h2,
body.theme-dark .dialog-content h3,
body.theme-dark .dialog-body h3 {
  color: var(--fc-fg) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/transfered-content-approvals/confirmation-dialog/confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAEF;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAEJ;AAAI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,gBAAA;AAEN;AACI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AACN;AACM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACR;AAEM;EACE,mBAAA;EACA,sBAAA;AAAR;AAGM;EACE,aAAA;AADR;AAIM;EACE,aAAA;AAFR;AAKM;EACE,wCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAQE;EACE,oBAAA;EACA,OAAA;EACA,gBAAA;EACA,iCAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAQM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AANR;AAQQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AANV;AASQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAPV;AAUQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AARV;AAWQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AATV;AAcI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAZN;AAcM;;EAEE,gBAAA;AAZR;AAeM;EACE,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AAbR;AAgBM;EACE,gBAAA;EACA,kBAAA;AAdR;AAkBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AAhBN;AAkBM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAhBR;AAmBM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,gBAAA;AAjBR;AAmBQ;EACE,gBAAA;AAjBV;AAoBQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAlBV;AAqBQ;EACE,WAAA;EACA,OAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAnBV;AAwBM;EAnDF;IAoDI,aAAA;EArBN;EAuBM;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;EArBR;EAuBQ;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;EArBV;EAwBQ;IACE,eAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EAtBV;AACF;AA2BI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAzBN;AA2BM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAzBR;AA4BM;EACE,eAAA;EACA,WAAA;AA1BR;AA4BQ;EACE,eAAA;EACA,gBAAA;AA1BV;AA6BQ;EACE,iBAAA;AA3BV;AA8BQ;EACE,aAAA;AA5BV;AA+BQ;EACE,kBAAA;AA7BV;AAoCE;EACE,6BAAA;EACA,oBAAA;EACA,wCAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,8BAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAlCJ;AAoCI;;EAEE,2BAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,+BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,oBAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EACA,qBAAA;EACA,4BAAA;EACA,iCAAA;EAGA,wCAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;AApCN;AAsCM;;EACE,iBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AAnCR;AAsCM;;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;AAnCR;AAqCQ;;EACE,oCAAA;EACA,gCAAA;EACA,sCAAA;EACA,mDAAA;AAlCV;AAqCQ;;EACE,mCAAA;AAlCV;AAsCM;;EACE,uBAAA;EACA,uBAAA;EACA,mDAAA;EACA,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AAnCR;AAqCQ;;EACE,8BAAA;AAlCV;AAoCU;;EACE,8BAAA;EACA,wDAAA;EACA,sCAAA;AAjCZ;AAoCU;;EACE,mCAAA;AAjCZ;AAqCQ;;EACE,8BAAA;AAlCV;AAoCU;;EACE,8BAAA;EACA,wDAAA;EACA,sCAAA;AAjCZ;AAoCU;;EACE,mCAAA;AAjCZ;AAqCQ;;EACE,8BAAA;AAlCV;AAoCU;;EACE,8BAAA;EACA,wDAAA;EACA,sCAAA;AAjCZ;AAoCU;;EACE,mCAAA;AAjCZ;AAqCQ;;EACE,8BAAA;AAlCV;AAoCU;;EACE,8BAAA;EACA,wDAAA;EACA,sCAAA;AAjCZ;AAoCU;;EACE,mCAAA;AAjCZ;;AAyCA,iFAAA;AAEE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAvCJ;AAyCI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAvCN;AA0CM;;EACE,iBAAA;EACA,wCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAvCR;AA0CM;;EACE,YAAA;EACA,mBAAA;AAvCR;AA2CI;EACE,mBAAA;EACA,cAAA;AAzCN;AA2CM;EACE,mBAAA;AAzCR;AA6CI;EACE,mBAAA;EACA,cAAA;AA3CN;AA6CM;EACE,mBAAA;AA3CR;;AAiDA,kEAAA;AACA;EACE,sBAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,uDAAA;EACA,2BAAA;EACA,2BAAA;AA9CF;AAgDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;AA9CJ;AAgDI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA9CN;AAiDI;EACE,sBAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;AA/CN;AAkDM;;;EAGE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wCAAA;AAhDR;AAmDM;EACE,kCAAA;AAjDR;AAoDM;EAGE,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;AApDR;AAyDE;EACE,kBAAA;EACA,gBAAA;AAvDJ;AAyDI;EACE,SAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;AAvDN;AAyDM;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AAvDR;AAyDQ;EACE,gBAAA;EACA,UAAA;EACA,uBAAA;AAvDV;AAyDU;EACE,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AAvDZ;AA8DE;EACE,wBAAA;EACA,oBAAA;EACA,wCAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;EACA,iCAAA;EACA,2BAAA;AA5DJ;AA8DI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;AA5DN;AA8DM;;EACE,YAAA;EACA,mBAAA;AA3DR;AA+DI;EACE,mBAAA;EACA,YAAA;AA7DN;AA+DM;EACE,mBAAA;AA7DR;AAiEI;EACE,mBAAA;EACA,cAAA;AA/DN;AAiEM;EACE,mBAAA;AA/DR;AAoEI;;EAEE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,4BAAA;AAlEN;AAoEM;;;;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AAhER;AAmEM;;;;EAEE,8BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,0BAAA;AA/DR;;AAsEA;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;AAnEF;;AAsEA;EAGE,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AArEF;;AAyEA;EACE,wBAAA;EACA,iCAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;AAtEF;AAwEE;EACE,4BAAA;AAtEJ;AAwEI;EACE,4BAAA;AAtEN;AAwEM;EACE,4BAAA;AAtER;AAwEQ;EACE,4BAAA;EACA,8BAAA;AAtEV;;AA8EA;EACE,oCAAA;EACA,8BAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;AA3EF;;AA8EA;EACE,gBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,4BAAA;AA3EF;;AA8EA,kBAAA;AACA;EACE,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;AA3EF;;AA8EA,yCAAA;AACA;EACE,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,4BAAA;AA3EF;;AA8EA,yEAAA;AACA;EACE,+BAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;EACA,4BAAA;AA3EF;;AA8EA,oCAAA;AACA;EACE,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA3EF;;AA8EA,6CAAA;AACA;EACE,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA3EF;;AA8EA,qCAAA;AACA;EACE,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yDAAA;AA3EF;;AA6EA;EACE,8BAAA;AA1EF;;AA4EA;;EAEE,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yDAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AAzEF;;AA2EA;EACE,8BAAA;AAxEF;;AA2EA;EACE;IACE,sBAAA;IACA,oBAAA;EAxEF;EA2EA;IACE,WAAA;IACA,aAAA;EAzEF;AACF;AA4EA;EACE;IACE,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IAEA,wBAAA;IACA,iCAAA;IACA,8BAAA;IACA,qBAAA;EA3EF;EA6EE;IACE,oBAAA;EA3EJ;EA6EI;IACE,eAAA;IACA,gBAAA;EA3EN;EA8EI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EA5EN;EA8EM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5ER;EAiFE;IACE,uBAAA;IACA,+BAAA;IACA,gBAAA;EA/EJ;EAkFE;IACE,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,iCAAA;IACA,wBAAA;IACA,8BAAA;IACA,qBAAA;EAhFJ;EAkFI;IACE,sBAAA;IACA,6BAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;EAhFN;EAkFM;IACE,6BAAA;EAhFR;EAsFA;IACE,4BAAA;EApFF;AACF;AA0FI;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;AAxFN;AA2FI;;;;EAIE,8BAAA;EACA,iCAAA;EACA,uBAAA;EACA,uBAAA;EACA,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AAzFN;AA2FM;;;;EACE,8BAAA;EACA,oCAAA;AAtFR;;AA6FE;;;;;;;EAOE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA1FJ;AA6FE;;;;EAIE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA3FJ;AA8FE;;;;;;;;;;;;;;;EAeE,yBAAA;AA5FJ;AA+FE;EACE,8BAAA;EACA,qCAAA;AA7FJ;AAgGE;;EAEE,8BAAA;EACA,kDAAA;AA9FJ;AAiGE;EACE,8BAAA;EACA,kDAAA;AA/FJ;AAkGE;;EAEE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAhGJ;AAmGE;;EAEE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAjGJ;AAoGE;;;;EAIE,yBAAA;AAlGJ;AAqGE;;;;;;;;EAQE,yBAAA;AAnGJ;;AAuGA,yBAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AApGF;AAsGE;EACE,SAAA;AApGJ;AAsGI;EACE,WAAA;AApGN;AAuGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AArGN;AAwGI;EACE,WAAA;AAtGN;AAwGM;EACE,WAAA;AAtGR;AAyGM;EACE,sBAAA;EACA,kBAAA;AAvGR;AA0GM;EACE,6BAAA;AAxGR;AA2GM;EACE,eAAA;EACA,cAAA;AAzGR;AA2GQ;EACE,cAAA;EACA,YAAA;AAzGV;AA6GM;EACE,cAAA;EACA,eAAA;AA3GR;;AAiHA;EACE;IACE,iBAAA;IACA,aAAA;EA9GF;AACF;AAiHA,2CAAA;AACA;EACE,oBAAA;AA/GF;;AAkHA;EACE,uBAAA;AA/GF;;AAkHA;EACE,iBAAA;EACA,aAAA;AA/GF;;AAkHA;EACE,6BAAA;EACA,4BAAA;AA/GF;;AAqHI;;;EAGE,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AAlHN;AAoHM;;;EACE,4BAAA;EACA,uBAAA;EACA,2BAAA;AAhHR;AAkHQ;;;EACE,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,mBAAA;AA9GV;AAgHU;;;EACE,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;AA5GZ;AAkHI;EACE,8BAAA;EACA,sBAAA;AAhHN;AAkHM;EACE,8BAAA;AAhHR;;AAsHA,+CAAA;AACA;;;EAGE,4BAAA;AAnHF;AAqHE;;;EACE,sBAAA;AAjHJ;AAoHE;;;EACE,uBAAA;AAhHJ;;AAwHA;;;EAGE,oCAAA;EACA,8BAAA;AArHF;;AAwHA;;;;;EAKE,oCAAA;EACA,8BAAA;EACA,yCAAA;AArHF;;AAwHA;;;;;;EAME,8BAAA;EACA,8BAAA;EACA,yCAAA;AArHF;;AAwHA;;;;;;;;;;;;EAYE,8BAAA;AArHF","sourcesContent":[".confirmation-dialog {\n  width: 100%;\n  max-width: 650px;\n  border-radius: 12px;\n  overflow: visible; // Changed from hidden to visible to prevent cutting off close button\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n\n  .dialog-header {\n    padding: 20px 24px;\n    margin-bottom: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    border-bottom: 1px solid #e0e0e0;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      color: #111827;\n      flex: 1;\n      line-height: 1.3;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: transparent;\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n        border-color: #e5e7eb;\n      }\n\n      &:active {\n        background: #e5e7eb;\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-family: \"Material Icons\" !important;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .confirmation-content {\n    padding: 0 24px 24px;\n    flex: 1;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    .status-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 24px 0 20px;\n\n      .icon-circle {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 28px;\n        transition: all 0.3s ease;\n\n        &.approve {\n          background-color: #e8f5e8;\n          color: #2e7d32;\n          border: 2px solid #4caf50;\n        }\n\n        &.reject {\n          background-color: #ffebee;\n          color: #c62828;\n          border: 2px solid #f44336;\n        }\n\n        &.rework {\n          background-color: #fff3e0;\n          color: #ef6c00;\n          border: 2px solid #ff9800;\n        }\n\n        &.cancel {\n          background-color: #f3e5f5;\n          color: #7b1fa2;\n          border: 2px solid #9c27b0;\n        }\n      }\n    }\n\n    .confirmation-message {\n      margin-bottom: 24px;\n      padding: 16px;\n      background-color: #fff;\n      border-radius: 8px;\n      border-left: 4px solid #2196f3;\n      font-size: 16px;\n      line-height: 1.6;\n      color: #333;\n      text-align: left;\n\n      .status-message,\n      .next-steps {\n        text-align: left;\n      }\n\n      ul {\n        margin: 8px 0 0 0;\n        padding-left: 24px;\n        list-style-position: outside;\n        text-align: left;\n      }\n\n      li {\n        text-align: left;\n        display: list-item;\n      }\n    }\n\n    .request-details {\n      background-color: #f8f9fa;\n      border-radius: 8px;\n      padding: 20px;\n      margin-bottom: 20px;\n      border: 1px solid #e9ecef;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n      .section-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 16px;\n        padding-bottom: 8px;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n      .detail-item {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 16px;\n        gap: 0;\n        min-height: 24px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .label {\n          font-weight: 600;\n          color: #666;\n          min-width: 120px;\n          flex-shrink: 0;\n          text-align: right;\n          padding-right: 16px;\n          font-size: 14px;\n          line-height: 1.4;\n        }\n\n        .value {\n          color: #333;\n          flex: 1;\n          word-break: break-word;\n          font-size: 14px;\n          line-height: 1.4;\n          padding-left: 8px;\n          font-weight: 500;\n        }\n      }\n\n      // Responsive design for smaller screens\n      @media (max-width: 600px) {\n        padding: 16px;\n\n        .detail-item {\n          flex-direction: column;\n          align-items: flex-start;\n          margin-bottom: 20px;\n\n          .label {\n            min-width: auto;\n            text-align: left;\n            padding-right: 0;\n            padding-bottom: 4px;\n            font-size: 13px;\n            color: #555;\n          }\n\n          .value {\n            padding-left: 0;\n            font-size: 14px;\n            font-weight: 600;\n            color: #222;\n          }\n        }\n      }\n    }\n\n    .comment-section {\n      margin-top: 24px;\n      padding: 20px;\n      background-color: #fff;\n      border-radius: 8px;\n      border: 1px solid #e0e0e0;\n\n      .section-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 16px;\n        padding-bottom: 8px;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n      mat-form-field {\n        margin-top: 8px;\n        width: 100%;\n\n        textarea {\n          font-size: 14px;\n          line-height: 1.5;\n        }\n\n        .mat-form-field-wrapper {\n          padding-bottom: 0;\n        }\n\n        .mat-form-field-underline {\n          display: none;\n        }\n\n        .mat-form-field-outline {\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n\n  // Target Material Design dialog actions with more specific selectors\n  mat-dialog-actions.mat-dialog-actions {\n    padding: 16px 24px !important;\n    margin: 0 !important;\n    border-top: 1px solid #e0e0e0 !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    align-content: center !important;\n    gap: 12px !important;\n    background-color: #fafafa !important;\n    flex-shrink: 0;\n    visibility: visible !important;\n    opacity: 1 !important;\n    overflow: visible !important;\n    min-height: 76px !important;\n\n    button.mat-button,\n    button.mat-raised-button {\n      min-width: 100px !important;\n      font-weight: 500 !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.5px !important;\n      border-radius: 6px !important;\n      transition: all 0.3s ease !important;\n      padding: 12px 20px !important;\n      border: none !important;\n      cursor: pointer !important;\n      font-family: inherit !important;\n      height: 44px !important;\n      min-height: 44px !important;\n      line-height: 1.2 !important;\n      margin: 0 !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n      display: inline-flex !important;\n      align-items: center !important;\n      align-self: center !important;\n      justify-content: center !important;\n      vertical-align: middle !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n      overflow: visible !important;\n      box-sizing: border-box !important;\n\n      // Override Material Design button styles completely\n      background-color: transparent !important;\n      color: inherit !important;\n      border: inherit !important;\n      box-shadow: none !important;\n      outline: none !important;\n      \n      mat-icon {\n        margin-right: 6px;\n        font-size: 20px !important;\n        width: 20px !important;\n        height: 20px !important;\n        overflow: visible !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        display: inline-flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n      }\n\n      &.cancel-btn {\n        color: #666 !important;\n        border: 1px solid #ddd !important;\n        background-color: #f8f9fa !important;\n\n        &:hover {\n          background-color: #e9ecef !important;\n          border-color: #adb5bd !important;\n          transform: translateY(-1px) !important;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n        }\n\n        &:active {\n          transform: translateY(0) !important;\n        }\n      }\n\n      &.confirm-btn {\n        color: white !important;\n        border: none !important;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n        overflow: visible !important;\n        height: 44px !important;\n        min-height: 44px !important;\n        padding: 0 20px !important;\n        display: inline-flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n\n        &.approve {\n          background: #5ea1d8 !important;\n\n          &:hover {\n            background: #4a90c6 !important;\n            box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.reject {\n          background: #5ea1d8 !important;\n\n          &:hover {\n            background: #4a90c6 !important;\n            box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.rework {\n          background: #5ea1d8 !important;\n\n          &:hover {\n            background: #4a90c6 !important;\n            box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.cancel {\n          background: #5ea1d8 !important;\n\n          &:hover {\n            background: #4a90c6 !important;\n            box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Flow Completion–style primary/secondary buttons for ALL confirmation dialogs */\n.confirmation-dialog {\n  mat-dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 24px;\n    margin-top: 4px;\n\n    .btn-primary,\n    .btn-secondary {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: none;\n      font-family: \"Raleway\", sans-serif;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      box-sizing: border-box;\n\n      // Space between icon and label\n      mat-icon {\n        margin-right: 8px;\n        font-family: \"Material Icons\" !important;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: #ffffff;\n\n      &:hover:not(:disabled) {\n        background: #4a8fc4;\n      }\n    }\n\n    .btn-secondary {\n      background: #f3f4f6;\n      color: #374151;\n\n      &:hover:not(:disabled) {\n        background: #e5e7eb;\n      }\n    }\n  }\n}\n\n/* Simplified visual style for generic stay/leave discard dialog */\n.confirmation-dialog.simple-confirmation {\n  width: 100% !important;\n  max-width: 500px !important;\n  min-width: 400px !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n  background: #ffffff !important;\n  border-radius: 22px !important;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35) !important;\n  overflow: hidden !important;\n  position: static !important;\n\n  .dialog-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #ffffff;\n    border-top-left-radius: 22px;\n    border-top-right-radius: 22px;\n    position: static !important;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 500;\n      color: #333;\n    }\n\n    .close-button {\n      color: #666 !important;\n      background: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n\n      // Match Flow Completion close icon (no background/ripple box)\n      ::ng-deep .mat-mdc-button-base,\n      ::ng-deep .mdc-icon-button,\n      ::ng-deep .mat-mdc-icon-button {\n        background: transparent !important;\n        border: none !important;\n        box-shadow: none !important;\n        background-color: transparent !important;\n      }\n\n      ::ng-deep .mdc-icon-button__ripple {\n        background: transparent !important;\n      }\n\n      &:hover,\n      &:focus,\n      &:active {\n        background: transparent !important;\n        background-color: transparent !important;\n        border: none !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  .confirmation-content {\n    padding: 32px 24px;\n    text-align: left;\n\n    .confirmation-message {\n      margin: 0;\n      padding: 0;\n      border-left: none;\n      background: transparent;\n\n      .status-message {\n        margin: 0;\n        padding: 0;\n        background: transparent;\n        border: none;\n\n        .next-steps {\n          margin-top: 12px;\n          padding: 0;\n          background: transparent;\n\n          ul {\n            margin: 8px 0 0 0;\n            padding-left: 24px;\n            list-style-position: outside;\n            text-align: left;\n          }\n        }\n      }\n    }\n  }\n\n  mat-dialog-actions.mat-dialog-actions {\n    padding: 25px !important;\n    margin: 0 !important;\n    border-top: 1px solid #e0e0e0 !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    gap: 12px !important;\n    background-color: #fff !important;\n    position: static !important;\n\n    .btn-primary,\n    .btn-secondary {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: none;\n      font-family: \"Raleway\";\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: white;\n\n      &:hover:not(:disabled) {\n        background: #4a8fc4;\n      }\n    }\n\n    .btn-secondary {\n      background: #f3f4f6;\n      color: #374151;\n\n      &:hover:not(:disabled) {\n        background: #e5e7eb;\n      }\n    }\n\n    // Ensure MDC button internals follow Flow Completion sizing/alignment\n    button.mat-button,\n    button.mat-raised-button {\n      font-family: \"Raleway\" !important;\n      min-width: 100px !important;\n      height: auto !important;\n      min-height: auto !important;\n      max-height: none !important;\n      text-transform: none !important;\n      letter-spacing: normal !important;\n      border-radius: 8px !important;\n      padding: 10px 16px !important;\n      margin: 0 !important;\n      display: inline-flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      box-sizing: border-box !important;\n      overflow: visible !important;\n\n      ::ng-deep .mat-mdc-button-base,\n      ::ng-deep .mdc-button {\n        height: auto !important;\n        min-height: auto !important;\n        max-height: none !important;\n        padding: 10px 16px !important;\n        margin: 0 !important;\n        display: inline-flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n      }\n\n      ::ng-deep .mat-button-wrapper,\n      ::ng-deep .mdc-button__label {\n        white-space: nowrap !important;\n        display: inline-flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        gap: 8px !important;\n        font-size: 16px !important;\n      }\n    }\n  }\n}\n\n// Additional global overrides for Material Design buttons - using more specific selectors\n.confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {\n  color: #666 !important;\n  border: 1px solid #ddd !important;\n  background-color: #f8f9fa !important;\n}\n\n.confirmation-dialog\n  mat-dialog-actions\n  button.mat-raised-button.confirm-btn.approve {\n  background: #5ea1d8 !important;\n  color: white !important;\n  border: none !important;\n  height: 44px !important;\n  min-height: 44px !important;\n  padding: 0 20px !important;\n  overflow: visible !important;\n}\n\n// Ensure dialog is properly centered and not clipped\n::ng-deep .mat-dialog-container {\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 0 !important;\n  max-height: 90vh !important;\n  overflow: visible !important;\n  box-sizing: border-box !important;\n  \n  .confirmation-dialog {\n    overflow: visible !important;\n    \n    mat-dialog-actions {\n      overflow: visible !important;\n      \n      button {\n        overflow: visible !important;\n        \n        .mat-icon {\n          overflow: visible !important;\n          visibility: visible !important;\n        }\n      }\n    }\n  }\n}\n\n// Fix button alignment issues\n::ng-deep .confirmation-dialog mat-dialog-actions {\n  justify-content: flex-end !important;\n  align-items: center !important;\n}\n\n.confirmation-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n}\n\n.dialog-header {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 2;\n}\n\n.confirmation-content {\n  overflow-y: auto;\n}\n\nmat-dialog-actions.mat-dialog-actions {\n  position: sticky;\n  bottom: 0;\n  background: #fafafa;\n  z-index: 2;\n  overflow: visible !important;\n}\n\n/* Align actions */\nmat-dialog-actions.mat-dialog-actions {\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 12px;\n  padding: 16px 24px !important;\n  overflow: visible !important;\n  min-height: 76px !important;\n}\n\n/* Normalize MDC buttons inside actions */\nmat-dialog-actions .mat-mdc-button-base {\n  height: 44px !important;\n  min-height: 44px !important;\n  min-width: 120px;\n  padding: 0 20px !important;\n  margin: 6px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  overflow: visible !important;\n}\n\n/* Ensure the internal MDC label area uses flex for icon/text alignment */\nmat-dialog-actions .mat-mdc-button-base .mdc-button__label {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px;\n  line-height: 1;\n  overflow: visible !important;\n}\n\n/* Standardize icon size/alignment */\nmat-dialog-actions .mat-mdc-button-base .mat-icon {\n  font-size: 20px !important;\n  height: 20px !important;\n  width: 20px !important;\n  line-height: 20px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  overflow: visible !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Visual for cancel button to match sizing */\nbutton.cancel-btn {\n  border: 1px solid #ddd;\n  background-color: #f8f9fa;\n  color: #444;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Flowchest button style overrides */\n.confirmation-dialog mat-dialog-actions button.confirm-btn.approve {\n  background: #5ea1d8 !important;\n  color: #fff !important;\n  border: none !important;\n  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;\n}\n.confirmation-dialog mat-dialog-actions button.confirm-btn.approve:hover {\n  background: #4a90c6 !important;\n}\n.confirmation-dialog mat-dialog-actions button.confirm-btn.reject,\n.confirmation-dialog mat-dialog-actions button.confirm-btn.cancel {\n  background: #5ea1d8 !important;\n  color: #fff !important;\n  border: none !important;\n  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;\n  height: 44px !important;\n  min-height: 44px !important;\n  padding: 0 20px !important;\n  overflow: visible !important;\n}\n.confirmation-dialog mat-dialog-actions button.confirm-btn.reject:hover {\n  background: #4a90c6 !important;\n}\n\n@media (max-width: 600px) {\n  mat-dialog-actions.mat-dialog-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  mat-dialog-actions .mat-mdc-button-base {\n    width: 100%;\n    margin: 6px 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .confirmation-dialog {\n    width: calc(100vw - 24px);\n    max-width: 415px;\n    margin: 12px auto;\n    border-radius: 0;\n    // max-height: 100vh;\n    display: flex !important;\n    flex-direction: column !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n\n    .dialog-header {\n      padding: 16px 16px 0;\n\n      h2 {\n        font-size: 18px;\n        line-height: 1.2;\n      }\n\n      .close-button {\n        width: 36px;\n        height: 36px;\n        min-width: 36px;\n        min-height: 36px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n\n    .confirmation-content {\n      padding: 12px 16px 16px;\n      max-height: calc(100vh - 140px);\n      overflow-y: auto;\n    }\n\n    mat-dialog-actions {\n      position: sticky;\n      bottom: 0;\n      background: #fafafa;\n      flex-direction: column !important;\n      display: flex !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n\n      button {\n        width: 100% !important;\n        margin-bottom: 8px !important;\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n\n        &:last-child {\n          margin-bottom: 5px !important;\n        }\n      }\n    }\n  }\n\n  ::ng-deep .mat-dialog-container {\n    max-height: 100vh !important;\n  }\n}\n\n// Additional high-specificity overrides to ensure button colors\n::ng-deep .confirmation-dialog {\n  mat-dialog-actions {\n    button.mat-button.cancel-btn {\n      color: #666 !important;\n      border: 1px solid #ddd !important;\n      background-color: #f8f9fa !important;\n      background-image: none !important;\n    }\n\n    button.mat-raised-button.confirm-btn.approve,\n    button.mat-raised-button.confirm-btn.reject,\n    button.mat-raised-button.confirm-btn.rework,\n    button.mat-raised-button.confirm-btn.cancel {\n      background: #5ea1d8 !important;\n      background-image: none !important;\n      color: white !important;\n      border: none !important;\n      background-color: #5ea1d8 !important;\n      height: 44px !important;\n      min-height: 44px !important;\n      padding: 0 20px !important;\n      overflow: visible !important;\n      \n      &:hover {\n        background: #4a90c6 !important;\n        background-color: #4a90c6 !important;\n      }\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .confirmation-dialog,\n  .confirmation-dialog .dialog-header,\n  .confirmation-dialog .confirmation-content,\n  .confirmation-dialog .request-details,\n  .confirmation-dialog .comment-section,\n  .confirmation-dialog .comment-form-section,\n  .confirmation-dialog mat-dialog-actions.mat-dialog-actions {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .confirmation-dialog.simple-confirmation,\n  .confirmation-dialog.simple-confirmation .dialog-header,\n  .confirmation-dialog.simple-confirmation .confirmation-content,\n  .confirmation-dialog.simple-confirmation mat-dialog-actions.mat-dialog-actions {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .confirmation-dialog h2,\n  .confirmation-dialog h3,\n  .confirmation-dialog h4,\n  .confirmation-dialog p,\n  .confirmation-dialog span,\n  .confirmation-dialog label,\n  .confirmation-dialog .section-title,\n  .confirmation-dialog .detail-item .label,\n  .confirmation-dialog .detail-item .value,\n  .confirmation-dialog .confirmation-message,\n  .confirmation-dialog .status-message,\n  .confirmation-dialog .next-steps,\n  .confirmation-dialog .next-steps li,\n  .confirmation-dialog .close-button,\n  .confirmation-dialog .close-button mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .confirmation-dialog .confirmation-message {\n    background: #1f2937 !important;\n    border-left-color: #5ea1d8 !important;\n  }\n\n  .confirmation-dialog .request-details,\n  .confirmation-dialog .comment-form-section {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .confirmation-dialog .close-button:hover {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .confirmation-dialog mat-dialog-actions .btn-secondary,\n  .confirmation-dialog mat-dialog-actions .cancel-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border: 1px solid rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .confirmation-dialog mat-dialog-actions .btn-primary,\n  .confirmation-dialog mat-dialog-actions .confirm-btn {\n    background: #2563eb !important;\n    color: #ffffff !important;\n    border-color: #2563eb !important;\n  }\n\n  .confirmation-dialog mat-dialog-actions button,\n  .confirmation-dialog mat-dialog-actions button span,\n  .confirmation-dialog mat-dialog-actions button .mdc-button__label,\n  .confirmation-dialog mat-dialog-actions button mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .confirmation-dialog mat-dialog-actions .btn-primary,\n  .confirmation-dialog mat-dialog-actions .btn-primary span,\n  .confirmation-dialog mat-dialog-actions .btn-primary .mdc-button__label,\n  .confirmation-dialog mat-dialog-actions .btn-primary mat-icon,\n  .confirmation-dialog mat-dialog-actions .confirm-btn,\n  .confirmation-dialog mat-dialog-actions .confirm-btn span,\n  .confirmation-dialog mat-dialog-actions .confirm-btn .mdc-button__label,\n  .confirmation-dialog mat-dialog-actions .confirm-btn mat-icon {\n    color: #ffffff !important;\n  }\n}\n\n/* Comment Form Styling */\n.comment-form-section {\n  margin: 20px 24px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n\n  .example-form {\n    margin: 0;\n\n    .w-100 {\n      width: 100%;\n    }\n\n    .font16 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #495057;\n    }\n\n    mat-form-field {\n      width: 100%;\n\n      .mat-mdc-form-field {\n        width: 100%;\n      }\n\n      .mat-mdc-text-field-wrapper {\n        background-color: #fff;\n        border-radius: 6px;\n      }\n\n      .mat-mdc-form-field-focus-overlay {\n        background-color: transparent;\n      }\n\n      input {\n        font-size: 14px;\n        color: #495057;\n\n        &::placeholder {\n          color: #6c757d;\n          opacity: 0.7;\n        }\n      }\n\n      .mat-mdc-form-field-hint {\n        color: #6c757d;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .comment-form-section {\n    margin: 12px 12px;\n    padding: 12px;\n  }\n}\n\n/* Spacing adjustments for better padding */\n.dialog-header {\n  padding: 16px 24px 0;\n}\n\n.confirmation-content {\n  padding: 16px 24px 16px;\n}\n\n.comment-form-section {\n  margin: 16px 24px;\n  padding: 16px;\n}\n\nmat-dialog-actions.mat-dialog-actions {\n  padding: 16px 24px !important;\n  overflow: visible !important;\n}\n\n// Additional global overrides to ensure button visibility\n::ng-deep .confirmation-dialog {\n  mat-dialog-actions {\n    .mat-mdc-button,\n    .mat-mdc-raised-button,\n    .mat-mdc-unelevated-button {\n      overflow: visible !important;\n      height: 44px !important;\n      min-height: 44px !important;\n      padding: 0 20px !important;\n      \n      .mdc-button {\n        overflow: visible !important;\n        height: 44px !important;\n        min-height: 44px !important;\n        \n        .mdc-button__label {\n          overflow: visible !important;\n          display: inline-flex !important;\n          align-items: center !important;\n          gap: 8px !important;\n          \n          mat-icon {\n            overflow: visible !important;\n            visibility: visible !important;\n            opacity: 1 !important;\n            font-size: 20px !important;\n            height: 20px !important;\n            width: 20px !important;\n            line-height: 20px !important;\n          }\n        }\n      }\n    }\n    \n    button.confirm-btn {\n      background: #5ea1d8 !important;\n      color: #fff !important;\n      \n      &:hover {\n        background: #4a90c6 !important;\n      }\n    }\n  }\n}\n\n/* Add border on all sides for action buttons */\nmat-dialog-actions.mat-dialog-actions button.mat-button,\nmat-dialog-actions.mat-dialog-actions button.mat-raised-button,\nmat-dialog-actions .mat-mdc-button-base {\n  overflow: visible !important;\n  \n  &.cancel-btn {\n    border: 1px solid #ddd;\n  }\n  \n  &.confirm-btn {\n    border: none !important;\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – dialog component\n// ════════════════════════════════════════════════\nbody.theme-dark .mat-mdc-dialog-container,\nbody.theme-dark .mdc-dialog__container,\nbody.theme-dark .mdc-dialog__surface {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dialog-content,\nbody.theme-dark .dialog-body,\nbody.theme-dark .modal-content,\nbody.theme-dark .confirmation-dialog,\nbody.theme-dark .response-dialog {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dialog-content input,\nbody.theme-dark .dialog-body input,\nbody.theme-dark .dialog-content select,\nbody.theme-dark .dialog-body select,\nbody.theme-dark .dialog-content textarea,\nbody.theme-dark .dialog-body textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dialog-content p,\nbody.theme-dark .dialog-body p,\nbody.theme-dark .dialog-content span:not(.material-icons),\nbody.theme-dark .dialog-body span:not(.material-icons),\nbody.theme-dark .dialog-content label,\nbody.theme-dark .dialog-body label,\nbody.theme-dark .dialog-content h1,\nbody.theme-dark .dialog-body h1,\nbody.theme-dark .dialog-content h2,\nbody.theme-dark .dialog-body h2,\nbody.theme-dark .dialog-content h3,\nbody.theme-dark .dialog-body h3 {\n  color: var(--fc-fg) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
